import React, { useContext, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
// import { HiUser } from 'react-icons/hi2'
import Loader from './loader/Loader';
import axios from 'axios';
import UserDetails from '../context/UserDetails';

const LoginForm = () => {

    const [user, setUser] = useState('')
    const [password, setPassWord] = useState('')
    const [loader, setLoader] = useState(false)
    const router = useNavigate()
    const {setUser:setUserSate, setToken } = useContext(UserDetails)

    const handleSubmit = async e => {
        e.preventDefault()
        try {
            setLoader(true)
            const login = await axios.post('api/users/login/', new FormData(e.target), {
                headers: {
                    "Content-Type": 'application/json'
                }
            })
            if (login.status === 200) {
                const data = login.data
                setToken(data?.token || "")
                setUserSate(data?.user_data || {})
                window.sessionStorage.setItem('token', data?.token)
                window.sessionStorage.setItem('user', JSON.stringify(data?.user_data))
                window.localStorage.setItem('user', data?.user_data?.first_name+" "+data?.user_data?.last_name)
                router('/home')
            }
        } catch (e) {
            console.log(e)
            setLoader(false)
        }
    }

    return (
        <div className='login-form-wrapper flex-1'>
            <div className='login-form-container'>
                <div className='login-form-icon-wrapper'>
                    <div className='login-form-icon'>
                        <img src={'/sidebar-profile.png'} width={70} height={70} alt='profile-placeholder' />
                    </div>

                    <div>
                        <p className='font-medium text-lg capitalize'>Welcome, {window.localStorage.getItem('user') || "User"}</p>
                    </div>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className={`login-input-group ${user ? 'hasValue' : ''}`}>
                        <input name='customer_id ' id='user' type='text' value={user} required={true} onChange={e => setUser(e.target.value)} />
                        <label htmlFor='user'>Customer ID</label>
                    </div>
                    <div className={`login-input-group ${password ? 'hasValue' : ''}`}>
                        <input name='password' id='password' type='password' required={true} value={password} onChange={e => setPassWord(e.target.value)} />
                        <label htmlFor='password'>Password</label>
                    </div>
                    <div className='my-3'>
                        <small>
                            <Link className='small-text login-link' to='/'>Forgot Password?</Link>
                        </small>
                    </div>
                    <div>
                        <button className='login-btn w-100 text-center' type='submit'>Login</button>
                    </div>
                    <hr className='border-gray-950 my-4'/>
                    <div className='mt-3 text-center'>
                        <p>
                            Not <span className='capitalize'>{window.localStorage.getItem('user') || "User"}</span>? <Link className='cta-link' to='/' >Add another user</Link>
                        </p>

                    </div>
                    <div className='mt-1 text-center'>
                        <span className='cta-link'>
                            Secure Banking
                        </span>
                        <span className='mx-1'>|</span>
                        <span className='cta-link'>
                            Privacy Policy
                        </span>
                    </div>
                </form>
            </div>
            <Loader show={loader} message={'Securely logging in'} overlay={true} />
        </div>
    )
}

export default LoginForm